import getHost from './host';

export default getHost;
